import React from "react";
import Common_Back_Btn from "../../common_components/common_back_btn/Common_Back_Btn";
import Product_Image from "../../product_details/product_image/Product_Image";
import Ordered_Product_details_card from "./ordered_Product_details_card/Ordered_Product_details_card";
import Perfect_Partner from "../../product_details/perfect_partner/Perfect_Partner";
import Ordered_Product_details_tabs from "./ordered_Product_details_tabs/Ordered_Product_details_tabs";

const Ordered_Product_details = () => {
  return (
    <section className="Product_Details">
      <div className="custom_container">
        <Common_Back_Btn backText="Back" />

        <div className="row">
          <div className="col-xl-8">
            <div className="left_side">
              <Product_Image />

              <div className="hidden_product_descn">
                <Ordered_Product_details_card />
              </div>
            </div>
          </div>
          <div className="col-xl-4">
            <div className="right_side">
              <Ordered_Product_details_card />
            </div>
          </div>
        </div>

        <Ordered_Product_details_tabs/>

        <Perfect_Partner />
      </div>
    </section>
  );
};

export default Ordered_Product_details;
